import React, { useEffect, useState, useRef, memo } from 'react';
import { Modal, Button, Form, Row, Col, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
import { AssignLeadsMarketerAndAdminAction } from '../Redux/Actions/UsersAction';
import { Notify } from '../Utility/Notify';
import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';
import { FaUserTie, FaUsers, FaHistory, FaEyeSlash } from 'react-icons/fa';

const chunkArray = (array, size) => {
  const chunked = [];
  for (let i = 0; i < array.length; i += size) {
    chunked.push(array.slice(i, i + size));
  }
  return chunked;
};

export const AssignLeadsFromManagerModel = memo(
  ({ show, onHide, selectedLeadsmanager = [], onAssignSuccess, refreshdata }) => {
    const dispatch = useDispatch();

    const [selectedOption, setSelectedOption] = useState('option1');
    const [selectedStage, setSelectedStage] = useState(null);
    const [userlogin, setuserlogin] = useState('');
    const [salesname, setsalesname] = useState('');
    const [selectedSalesDataArray, setSelectedSalesDataArray] = useState([]);
    const [clearHistory, setClearHistory] = useState(false);
    const [hideCreationDate, setHideCreationDate] = useState(false);
    const [loading, setloading] = useState(true);
    const [sendloading, setsendloading] = useState(false);
    const [assignType, setAssignType] = useState('salesman');

    // ✅ استخدام useRef لتخزين الـ leads بشكل ثابت
    const leadsRef = useRef([]);

    // ✅ استخدام useRef لتخزين آخر قيمة من selectedLeadsmanager عند فتح المودال فقط
    const initialLeadsRef = useRef([]);
    const isFirstOpenRef = useRef(true);

    // ✅ هذا الـ useEffect يشغل مرة واحدة فقط عند فتح المودال
    useEffect(() => {
      if (show) {
        // لو دي أول مرة نفتح فيها المودال أو المودال اتفتح من غير ما يتقفل
        if (
          isFirstOpenRef.current ||
          JSON.stringify(initialLeadsRef.current) !== JSON.stringify(selectedLeadsmanager)
        ) {
          console.log('📋 Modal opened with leads:', selectedLeadsmanager);
          leadsRef.current = selectedLeadsmanager;
          initialLeadsRef.current = selectedLeadsmanager;
          isFirstOpenRef.current = false;
        }
      } else {
        // لما المودال يتقفل، نعيد تعيين الـ refs
        isFirstOpenRef.current = true;
        initialLeadsRef.current = [];
      }
    }, [show]); // ✅ نراقب show فقط، مش selectedLeadsmanager

    // استخدم leadsRef.current في كل مكان
    const leadsall = leadsRef.current;

    useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      setuserlogin(user);
    }, []);

    useEffect(() => {
      const getData = async () => {
        await dispatch(Get_All_Sales_Action());
        await dispatch(GetAll_stage_Data());
      };
      getData();
    }, [dispatch]);

    const resSalesData = useSelector((state) => state.AllSales.sales?.data || []);
    const resStagesData = useSelector((state) => state.Allstages.stage?.data || []);
    const freshStage = resStagesData.find((stage) => stage.name === 'No Stage');

    // فلترة البيانات بناءً على نوع التعيين والـ Manager الحالي
    const filteredSalesData = React.useMemo(() => {
      if (!userlogin?.data?._id) return [];

      const salesUnderManager = resSalesData.filter((sales) => {
        if (sales?.Manager && sales.Manager._id) {
          return sales.Manager._id.toString() === userlogin.data._id.toString();
        }
        if (sales?.Manager && typeof sales.Manager === 'string') {
          return sales.Manager.toString() === userlogin.data._id.toString();
        }
        return false;
      });

      if (assignType === 'teamLeader') {
        return salesUnderManager.filter((sales) => sales?.userlog?.role === 'Team Leader');
      } else {
        return salesUnderManager.filter((sales) => sales?.userlog?.role !== 'Team Leader');
      }
    }, [resSalesData, assignType, userlogin]);

    // دالة إغلاق المودال
    const handleClose = () => {
      setSelectedSalesDataArray([]);
      setsalesname('');
      setSelectedStage(null);
      setSelectedOption('option1');
      setClearHistory(false);
      setHideCreationDate(false);
      setAssignType('salesman');

      // ✅ نفضي الـ refs
      leadsRef.current = [];
      initialLeadsRef.current = [];
      isFirstOpenRef.current = true;

      onHide();
    };

    const stagechange = (e) => {
      setSelectedStage(e.target.value);
    };

    const onsaleschange = (e) => {
      const selectedId = e.target.value;
      if (selectedId) {
        const selected = filteredSalesData.find((s) => s._id === selectedId);
        setsalesname(selectedId);
        setSelectedSalesDataArray([selected]);
      } else {
        setsalesname('');
        setSelectedSalesDataArray([]);
      }
    };

    const senddleedtosalesaction = async (e) => {
      e.preventDefault();
      if (!salesname) return Notify('error', 'Please select sales', 'error');
      if (leadsall.length === 0) return Notify('error', 'No leads selected', 'error');

      setloading(true);
      setsendloading(true);

      try {
        const assignTypeBoolean = assignType === 'teamLeader';

        let stageValue = null;

        if (selectedOption === 'option2' && selectedStage) {
          stageValue = selectedStage;
        }

        const leadChunks = chunkArray(leadsall, 10);

        for (const chunk of leadChunks) {
          await Promise.all(
            chunk.map(async (leadId) => {
              return await dispatch(
                AssignLeadsMarketerAndAdminAction(
                  leadId,
                  userlogin?.data?._id,
                  salesname,
                  clearHistory,
                  stageValue,
                  assignTypeBoolean,
                  hideCreationDate,
                ),
              );
            }),
          );
        }

        Notify(
          'success',
          `Leads assigned successfully as ${assignType === 'teamLeader' ? 'Team Leader' : 'Salesman'}`,
          'success',
        );

        // ✅ إزالة الـ leads التي تم تعيينها من localStorage
        const currentStorage = JSON.parse(localStorage.getItem('selectedleedsbymanagers2') || '[]');
        const updatedStorage = currentStorage.filter((id) => !leadsall.includes(id));
        localStorage.setItem('selectedleedsbymanagers2', JSON.stringify(updatedStorage));

        // استدعاء onAssignSuccess مع الـ leads التي تم تعيينها
        if (onAssignSuccess) {
          onAssignSuccess(leadsall);
        }

        handleClose();
        refreshdata();
      } catch (err) {
        console.error('❌ Error in assignment:', err);
        Notify('error', 'Failed to assign leads', 'error');
      } finally {
        setloading(false);
        setsendloading(false);
      }
    };

    return (
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        centered
        backdrop="static"
        className="assign-leads-modal"
      >
        <Modal.Header
          closeButton
          style={{
            backgroundColor: '#f8f9fa',
            borderBottom: '1px solid #e9ecef',
            padding: '1.5rem',
          }}
        >
          <Modal.Title
            style={{
              color: '#102dff',
              fontWeight: '600',
              fontSize: '1.5rem',
            }}
          >
            <FaHistory style={{ marginRight: '10px', marginBottom: '5px' }} />
            Assign Leads (Manager View)
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: '1.5rem' }}>
          {/* Selected Leads Info */}
          <Card
            className="mb-4"
            style={{
              backgroundColor: '#f0f7ff',
              border: 'none',
              borderRadius: '10px',
            }}
          >
            <Card.Body className="py-3">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <span style={{ fontSize: '1.2rem', marginRight: '10px' }}>📋</span>
                  <span style={{ fontWeight: '600', color: '#102dff' }}>Selected Leads</span>
                </div>
                <span
                  style={{
                    backgroundColor: '#102dff',
                    color: 'white',
                    padding: '4px 12px',
                    borderRadius: '20px',
                    fontSize: '0.9rem',
                    fontWeight: '600',
                  }}
                >
                  {leadsall.length} Lead{leadsall.length !== 1 ? 's' : ''}
                </span>
              </div>
            </Card.Body>
          </Card>

          {/* Assignment Type */}
          <h6
            style={{
              color: '#495057',
              fontWeight: '600',
              marginBottom: '15px',
            }}
          >
            Assignment Type
          </h6>

          <Row className="mb-4">
            <Col md={6}>
              <Card
                onClick={() => setAssignType('salesman')}
                style={{
                  cursor: 'pointer',
                  border: assignType === 'salesman' ? '2px solid #102dff' : '1px solid #dee2e6',
                  backgroundColor: assignType === 'salesman' ? '#f0f7ff' : 'white',
                  borderRadius: '10px',
                  transition: 'all 0.2s ease',
                }}
                className="h-100"
              >
                <Card.Body className="text-center py-4">
                  <FaUserTie
                    style={{
                      fontSize: '2rem',
                      color: assignType === 'salesman' ? '#102dff' : '#6c757d',
                      marginBottom: '10px',
                    }}
                  />
                  <h6
                    style={{
                      fontWeight: '600',
                      color: assignType === 'salesman' ? '#102dff' : '#495057',
                    }}
                  >
                    Assign as Salesman
                  </h6>
                  <small style={{ color: '#6c757d' }}>Individual sales person</small>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6}>
              <Card
                onClick={() => setAssignType('teamLeader')}
                style={{
                  cursor: 'pointer',
                  border: assignType === 'teamLeader' ? '2px solid #102dff' : '1px solid #dee2e6',
                  backgroundColor: assignType === 'teamLeader' ? '#f0f7ff' : 'white',
                  borderRadius: '10px',
                  transition: 'all 0.2s ease',
                }}
                className="h-100"
              >
                <Card.Body className="text-center py-4">
                  <FaUsers
                    style={{
                      fontSize: '2rem',
                      color: assignType === 'teamLeader' ? '#102dff' : '#6c757d',
                      marginBottom: '10px',
                    }}
                  />
                  <h6
                    style={{
                      fontWeight: '600',
                      color: assignType === 'teamLeader' ? '#102dff' : '#495057',
                    }}
                  >
                    Assign as Team Leader
                  </h6>
                  <small style={{ color: '#6c757d' }}>Team leader (manages team)</small>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Select Sales/Team Leader */}
          <Form.Group className="mb-4">
            <Form.Label
              style={{
                fontWeight: '600',
                color: '#495057',
              }}
            >
              Select {assignType === 'teamLeader' ? 'Team Leader' : 'Sales Person'}
            </Form.Label>
            <Form.Select
              value={salesname}
              onChange={onsaleschange}
              style={{
                borderRadius: '8px',
                padding: '10px',
                borderColor: '#dee2e6',
              }}
            >
              <option value="">Choose...</option>
              {filteredSalesData.length > 0 ? (
                filteredSalesData.map((sale) => (
                  <option key={sale._id} value={sale._id}>
                    {sale.name} {sale.userlog?.role ? `(${sale.userlog.role})` : ''}
                  </option>
                ))
              ) : (
                <option value="" disabled>
                  No options available
                </option>
              )}
            </Form.Select>
          </Form.Group>

          {/* Stage Options */}
          <h6
            style={{
              color: '#495057',
              fontWeight: '600',
              marginBottom: '15px',
            }}
          >
            Stage Options
          </h6>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Check
                type="radio"
                id="same-stage"
                label="Same Stage"
                name="stageOption"
                value="option1"
                checked={selectedOption === 'option1'}
                onChange={(e) => setSelectedOption(e.target.value)}
              />
              <small className="text-muted d-block ms-4">Keep current stage</small>
            </Col>

            <Col md={6}>
              <Form.Check
                type="radio"
                id="change-stage"
                label="Change Stage"
                name="stageOption"
                value="option2"
                checked={selectedOption === 'option2'}
                onChange={(e) => setSelectedOption(e.target.value)}
              />
              <small className="text-muted d-block ms-4">Select new stage</small>
            </Col>
          </Row>

          {selectedOption === 'option2' && (
            <Form.Group className="mb-4">
              <Form.Select value={selectedStage || ''} onChange={stagechange}>
                <option value="">Select Stage</option>
                {resStagesData.map((stage) => (
                  <option key={stage._id} value={stage._id}>
                    {stage.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          )}

          {/* Options */}
          <Row className="mb-4">
            <Col md={6}>
              <Form.Check
                type="checkbox"
                id="clear-history"
                label={
                  <span>
                    <FaHistory className="me-1" style={{ color: '#102dff' }} />
                    Clear previous comments
                  </span>
                }
                checked={clearHistory}
                onChange={(e) => setClearHistory(e.target.checked)}
              />
            </Col>

            <Col md={6}>
              <Form.Check
                type="checkbox"
                id="hide-creation"
                label={
                  <span>
                    <FaEyeSlash className="me-1" style={{ color: '#102dff' }} />
                    Hide creation date
                  </span>
                }
                checked={hideCreationDate}
                onChange={(e) => setHideCreationDate(e.target.checked)}
              />
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-between align-items-center">
          <small className="text-muted">
            {leadsall.length} lead{leadsall.length !== 1 ? 's' : ''} selected
          </small>
          <div>
            <Button
              variant="outline-secondary"
              onClick={handleClose}
              className="me-2"
              style={{ color: '#102dff' }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={senddleedtosalesaction}
              disabled={sendloading || !salesname || leadsall.length === 0}
              style={{ backgroundColor: '#102dff', borderColor: '#102dff' }}
            >
              {sendloading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Assigning...
                </>
              ) : (
                `Assign as ${assignType === 'teamLeader' ? 'Team Leader' : 'Salesman'}`
              )}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  },
);
